import { PayloadAction } from '@reduxjs/toolkit'
import { Location } from '@/features/location/types/locationModels'
import { LocationState } from '../slices/locationSlice'

export const setLocation = (state: LocationState, action: PayloadAction<Location>) => {
  state.id = action.payload.id
  state.name = action.payload.name
  state.contactName = action.payload.contactName
  state.contactPhone = action.payload.phone
  state.contactEmail = action.payload.email
}

export const clearLocation = (state: LocationState) => {
  state.id = ''
  state.name = ''
  state.contactName = ''
  state.contactPhone = ''
  state.contactEmail = ''
}
